export default "__VITE_ASSET__D9jg9LW4__"